import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { CustomButton } from "@/components/ui/Buttons";
import Token from "@/assets/icons/Token.svg";
import Modal from "../../ui/Modal";

import CreditCoin from "@/assets/icons/CreditCoin.svg";
import PlusIcon from "@/assets/icons/Plus.svg";
import PricingIcon from "@/assets/icons/PricingPlan.svg";
// import CreateProjectModal from "../../../pages/createOrder/components/CreateProjectModal";
import MobileHeader from "./mobileHeader";
import { TUser } from "@/types/types";
import {
  resetSelectedTeam,
  setUserAvailableRevisions,
} from "@/redux/feature/global/globalSlice";
import { logOut } from "@/redux/feature/auth/authSlice";
import UserDropDown from "@/components/ui/UserDropDown";
import { useGetClientCreditQuery } from "@/redux/api/nodeApi";

const Header = ({
  setInviteModalOpen,
}: {
  setInviteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [showCreateProjectModal, setShowCreateProjectModal] = useState(false);
  // const { userAvailableRevisions } = useAppSelector((state) => state.global);
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const credits = data?.data?.credits;
  const userData: TUser | undefined = data?.data;
  const name = userData?.fullName || "User";
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (userData) {
      dispatch(
        setUserAvailableRevisions(
          userData?.purchasedPlan?.planId?.availableRevisions
        )
      );
    }
  }, [userData]);
  return (
    <div className="flex  border-b border-[#setInviteModalOpen={setInviteModalOpen}DFDFDF] justify-between py-4 px-4 md:pl-12 md:pr-6">
      <DesktopHeader
        name={name}
        setInviteModalOpen={setInviteModalOpen}
        credits={credits}
        userData={userData}
        setShowCreateProjectModal={setShowCreateProjectModal}
      />
      <MobileHeader />
      {/* <Modal
        isOpen={showCreateProjectModal}
        setOpen={setShowCreateProjectModal}
      >
        <CreateProjectModal />
      </Modal> */}
    </div>
  );
};

// Desktop header
interface DesktopHeaderProps {
  name: string;
  credits: number | undefined;
  userData: TUser | undefined;
  setInviteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setShowCreateProjectModal: (value: boolean) => void;
}

const DesktopHeader = ({
  name,
  userData,
  credits,
  setInviteModalOpen,

  setShowCreateProjectModal,
}: DesktopHeaderProps) => {
  const email = useAppSelector((state) => state.auth.user?.email);
  const { data } = useGetClientCreditQuery(email as string);
  const creditBalance = data?.data?.balance;
  const { selectedTeam } = useAppSelector((state) => state.global);
  const dispatch = useAppDispatch();

  const handleBackToOwnWorkspace = () => {
    // Remove the team id from localstorage
    localStorage.removeItem("teamId");
    //Reset the global id
    dispatch(resetSelectedTeam());
  };

  const client_dashboard_baseUrl =
    import.meta.env.VITE_NODE_ENV === "development"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_DEV
      : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CLIENT_DASHBOARD_STAGE
      : import.meta.env.VITE_API_CLIENT_DASHBOARD_PROD;

  const handleRedirectToMainDashboard = () => {
    return (window.location.href = `${client_dashboard_baseUrl}/orders`);
  };
  return (
    <div className="hidden  md:flex items-center justify-between w-full">
      <div>
        <div className="flex gap-2 items-center">
          <h2 className="text-body-medium font-medium text-[#101828]">
            Welcome, {name}
          </h2>
          {credits === 0 && (
            <p className="text-[#6941C6] text-xs font-medium leading-[18px] py-[2px] px-2 rounded-2xl bg-[#F9F5FF]">
              Subscribe
            </p>
          )}
          {userData?.purchasedPlan?.planId && (
            <p className="text-[#6941C6] text-xs font-medium leading-[18px] py-[2px] px-2 rounded-2xl bg-[#F9F5FF]">
              {userData?.purchasedPlan?.planId.name}
            </p>
          )}
        </div>
        <p className="text-caption-large text-gray-500 mt-1">
          Easily create and manage orders here.
        </p>
      </div>
      <div className="flex items-center gap-x-4">
        {!selectedTeam ? (
          <div className="flex gap-x-4">
            <CustomButton
              border="1.5px solid #666666"
              padding="10px 16px"
              borderRadius="12px"
              onClick={() => setInviteModalOpen(true)}
              fontWeight="600"
              color="#666666"
              variant="outline"
              fontSize="14px"
            >
              Invite Member
            </CustomButton>
            {/* <CustomButton
              border="1.5px solid #FEC006"
              padding="10px 16px"
              borderRadius="12px"
              fontWeight="600"
              color="#FEC614"
              variant="outline"
              fontSize="14px"
            >
              <div className="flex items-center gap-x-2">
                <span className="text-[#FEC614]">
                  <CreditCoin />
                </span>
                {creditBalance}{" "}
                <span className="hidden md:block">Credits left</span>
              </div>
            </CustomButton> */}
            <Link
              to={"/pricing"}
              className="leading-5 tracking-normal font-medium border border-[#EAEBEB] px-3 py-2 flex items-center gap-x-2 rounded-xl"
            >
              <Token />
              <p className="text-[#252430] text-2xl">
                {creditBalance?.toFixed(2)}
              </p>
              <span className="text-[#858BA0] text-sm">Tokens</span>
              <div className="header-token-gradient px-3 py-[2.5px] rounded-[20px]">
                <p className="text-white text-xs">Add</p>
              </div>
            </Link>
            <UserDropDown />
          </div>
        ) : (
          <CustomButton
            border="1.5px solid #666666"
            padding="10px 16px"
            borderRadius="12px"
            onClick={() => handleBackToOwnWorkspace()}
            fontWeight="600"
            color="#666666"
            variant="outline"
            fontSize="14px"
          >
            Back to Own WorkSpace
          </CustomButton>
        )}
        {/* <CreateOrderButton onClick={() => setShowCreateProjectModal(true)} /> */}
      </div>
    </div>
  );
};

// Buttons

// Subscribe button
const SubscribeButton = () => (
  <Link to="/pricing">
    <CustomButton
      padding="10px 16px"
      backgroundColor="#FFF"
      borderRadius="8px"
      border="1px solid #FEC614"
      fontSize="14px"
      fontWeight="600"
      color="#D59F01"
    >
      <div className="flex items-center gap-x-2">
        <PricingIcon />
        Subscribe to a Plan
      </div>
    </CustomButton>
  </Link>
);

// Credit button
const CreditButton = ({ credits }: { credits: number }) => (
  <CustomButton
    border="1.5px solid #FEC006"
    padding="10px 16px"
    borderRadius="12px"
    fontWeight="600"
    color="#FEC614"
    variant="outline"
    fontSize="14px"
  >
    <div className="flex items-center gap-x-2">
      <span className="text-[#FEC614]">
        <CreditCoin />
      </span>
      {credits} <span className="hidden md:block">Credits left</span>
    </div>
  </CustomButton>
);

// Create order button
const CreateOrderButton = ({ onClick }: { onClick: () => void }) => (
  <CustomButton
    padding="10px 16px"
    onClick={onClick}
    backgroundColor="#ED5E00"
    borderRadius="12px"
    border="0px"
    fontSize="14px"
    fontWeight="600"
  >
    <div className="flex items-center gap-x-2">
      <PlusIcon /> Create New Order
    </div>
  </CustomButton>
);

export default Header;
